import { render, staticRenderFns } from "./AgentServiceSendButton.vue?vue&type=template&id=f1622238&scoped=true"
import script from "./AgentServiceSendButton.vue?vue&type=script&lang=js"
export * from "./AgentServiceSendButton.vue?vue&type=script&lang=js"
import style0 from "./AgentServiceSendButton.vue?vue&type=style&index=0&id=f1622238&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1622238",
  null
  
)

export default component.exports